import styled, { css } from 'styled-components';

import { bn } from 'utils/BigNumber';
import {
  addSeparators,
  formatNumberWithSubscriptZerosView,
  toShortNumber as toShortNumberFunc,
} from 'utils/helpers';

const Value = styled.span<{ $color: 'red' | 'green' | null }>`
  white-space: nowrap;

  ${(props) =>
    props.$color === 'green' &&
    css`
      color: #00e676;
    `}
  ${(props) =>
    props.$color === 'red' &&
    css`
      color: #ff1744;
    `}

  sub {
    font-family: 'Roboto';
    font-size: 120%;
  }
`;

type DataViewProps = {
  value: number | null | undefined;
  type?: 'dollars' | 'percent' | null;
  hasSign?: boolean;
  hasColor?: boolean;
  toFixed?: number | null;
  toView?: (value: number) => React.ReactNode;
  toShortNumber?: boolean;
  asTag?: string;
  className?: string;
};

export const DataView = (props: DataViewProps) => {
  const {
    value,
    type,
    hasSign,
    hasColor,
    toFixed,
    toView,
    toShortNumber = false,
    asTag,
    className,
  } = props;

  if (value === null || value === undefined) {
    return (
      <Value $color={null} as={asTag as any} className={className}>
        —
      </Value>
    );
  }

  const color = hasColor && value !== 0 ? (value > 0 ? 'green' : 'red') : null;
  const sign = hasSign && value > 0 ? '+' : value < 0 ? '-' : '';
  let lessSign = '';

  const valueAbs = Math.abs(value);
  const valueCut = typeof toFixed === 'number' ? valueAbs.toFixed(toFixed) : valueAbs;

  let viewValue: React.ReactNode = addSeparators(valueCut, ',');

  if (toShortNumber) {
    viewValue =
      +valueCut > 1
        ? toShortNumberFunc(+valueCut)
        : formatNumberWithSubscriptZerosView(bn(valueCut).toString());
  }

  if (typeof toFixed === 'number' && +valueCut === 0 && value !== 0) {
    viewValue = 1 / 10 ** toFixed;
    lessSign = '< ';
  }

  if (toView) {
    viewValue = toView(+valueCut);
  }

  return (
    <Value $color={color} as={asTag as any} className={className}>
      {lessSign}
      {sign}
      {type === 'dollars' && '$'}
      {viewValue}
      {type === 'percent' && '%'}
    </Value>
  );
};
